var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"45","height":"4.17391","rx":"2.08696","fill":"#9FD833","key":0}),React.createElement("rect",{"x":"13.125","y":"13.9131","width":"31.875","height":"4.17391","rx":"2.08696","fill":"#9FD833","key":1}),React.createElement("rect",{"y":"27.8262","width":"45","height":"4.17391","rx":"2.08696","fill":"#9FD833","key":2})]);
}

Burger.defaultProps = {"width":"45","height":"32","viewBox":"0 0 45 32","fill":"none"};

module.exports = Burger;

Burger.default = Burger;
